export default __webpack_public_path__ + "static/media/rev_f_software.637ce7b0.webp";